/* ALUNERO V3 : la galerie de la fiche SCZJ suit le sélecteur natif Shopify sans modifier le produit. */
(function () {
  const handle = 'support-pc-aluminium-sczj-pliable-reglable';
  function selectedColor(picker) {
    if (!picker) return null;
    const selected = Array.from(picker.querySelectorAll('input:checked, select'));
    for (const el of selected) {
      const value = String(el.value || '').toLocaleLowerCase('fr');
      if (value.includes('argent')) return 'silver';
      if (value.includes('gris') || value.includes('anthracite')) return 'gray';
    }
    return null;
  }
  function show(panel, color) {
    if (color !== 'silver' && color !== 'gray') return;
    panel.querySelectorAll('[data-sczj-variant-panel]').forEach(function (item) {
      item.hidden = item.getAttribute('data-sczj-variant-panel') !== color;
    });
  }
  function sync() {
    document.querySelectorAll('[data-sczj-product-gallery]').forEach(function (panel) {
      if (panel.getAttribute('data-product-handle') !== handle) return;
      const id = new URLSearchParams(location.search).get('variant');
      const fromUrl = id === panel.dataset.silverVariantId ? 'silver' : id === panel.dataset.grayVariantId ? 'gray' : null;
      const picker = document.querySelector('variant-picker[data-product-handle="' + handle + '"]');
      const color = selectedColor(picker) || fromUrl;
      if (color) show(panel, color);
    });
  }
  document.addEventListener('change', function (event) {
    const p = event.target && event.target.closest ? event.target.closest('variant-picker[data-product-handle="' + handle + '"]') : null;
    if (!p) return;
    const choice = selectedColor(p);
    if (!choice) return;
    document.querySelectorAll('[data-sczj-product-gallery]').forEach(function (panel) { show(panel, choice); });
  }, true);
  window.addEventListener('popstate', sync);
  document.addEventListener('shopify:section:load', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();